import React from 'react'
import PropTypes from 'prop-types'
import {observer} from 'mobx-react'
import Select from 'react-select'

const DEPTH = 3
const PLACEHOLDERS = ['カテゴリを選択してください', 'サブカテゴリを選択してください', 'さらに絞り込む']

@observer
export default class ReviewFormInnerProductInput extends React.Component {
  static propTypes = {
    reviewFormStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      options: Array(DEPTH).fill([]),
      selected: Array(DEPTH).fill(null),
    }
    this.abortControllers = {}
  }

  componentDidMount() {
    this.fetchCategories(null, 0)
  }

  componentWillUnmount() {
    Object.values(this.abortControllers).forEach(controller => controller.abort())
  }

  fetchCategories(parentId, level) {
    if (this.abortControllers[level]) {
      this.abortControllers[level].abort()
    }
    const controller = new AbortController()
    this.abortControllers[level] = controller

    const url = parentId
      ? `/api/categories/co_cats?parent_id=${parentId}`
      : '/api/categories/co_cats'

    fetch(url, { signal: controller.signal })
      .then(res => (res.ok ? res.json() : Promise.reject(res)))
      .then(data => {
        const options = this.state.options.map((opts, i) =>
          i === level ? data.map(c => ({ value: c.id, label: c.name, hasChildren: c.has_children })) : opts
        )
        this.setState({ options })
      })
      .catch(error => {
        if (error.name !== 'AbortError') console.error('failed to load categories:', error)
      })
  }

  handleChange(level, option) {
    const selected = this.state.selected.map((v, i) => {
      if (i === level) return option
      if (i > level) return null
      return v
    })
    const options = this.state.options.map((opts, i) => i > level ? [] : opts)
    this.setState({ selected, options })

    if (option) {
      if (option.hasChildren && level < DEPTH - 1) {
        this.fetchCategories(option.value, level + 1)
        this.setProductName('')
      } else {
        this.setProductName(option.label)
      }
    } else {
      this.setProductName('')
    }
  }

  setProductName(value) {
    this.props.reviewFormStore.userInputProductName = value
  }

  renderSelect(level) {
    const options = this.state.options[level]
    if (level > 0 && options.length === 0) return null

    return (
      <div key={level} style={level > 0 ? { marginTop: '8px' } : undefined}>
        <Select
          className="reviewpopup-Form_selectSuggestInput"
          inputId={level === 0 ? 'reviewer_product' : undefined}
          value={this.state.selected[level]}
          onChange={option => this.handleChange(level, option)}
          options={options}
          isClearable={true}
          placeholder={PLACEHOLDERS[level]}
          noOptionsMessage={() => '候補なし'}
        />
      </div>
    )
  }

  render() {
    return (
      <div className="reviewpopup-Form_content">
        <div className="reviewpopup-Form_title">
          <label htmlFor="reviewer_product">カテゴリ</label>
          <span className="required">※必須</span>
          <span className="co-gray-2">（売却希望商品のカテゴリ）</span>
        </div>
        <div>
          {Array.from({ length: DEPTH }, (_, i) => this.renderSelect(i))}
        </div>
      </div>
    )
  }
}
